<script setup lang="ts">
import NewHeader from '~/components/NewHeader.vue';
import NewFooter from '~/components/NewFooter.vue';
import ColorBg from '~/components/ColorBg.vue';
import HelpCenter from '~/components/HelpCenter.vue';

const { t } = useI18n();

useHead({
  title: t('seo.contact.title'),
  meta: [{ name: 'description', content: t('seo.contact.description') }],
});
</script>

<template>
  <div class="bg-neutral-950">
    <NewHeader />
    <ColorBg>
      <div class="contact-shell">
        <HelpCenter />
      </div>
    </ColorBg>
    <NewFooter />
  </div>
</template>

<style scoped>
.contact-shell {
  position: relative;
  z-index: 40;
  max-width: 720px;
  margin: 0 auto;
  padding: 8rem 1rem 4rem;
}
@media (min-width: 768px) {
  .contact-shell {
    padding-top: 10rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
</style>
